export default {
  description: {
    id: 'cms_youtube_consent_description',
    defaultMessage:
      'To play this video, we need your consent for YouTube to set cookies and trackers on your device. You can withdraw it at any time in your cookie settings',
  },
  button: {
    id: 'cms_youtube_consent_button',
    defaultMessage: 'Accept and watch',
  },
}
